import { twMerge } from "tailwind-merge";

/** The brand gradient, as drawn by the stripes: from the far edge inwards. */
const STRIPES = ["--orange", "--pink", "--magenta", "--purple", "--blue"];

export const StripesBackground = ({
  className,
  style,
}: {
  className?: string;
  style?: React.CSSProperties;
}) => (
  <div className="relative max-w-6xl mx-auto h-full">
    <div
      className={twMerge(
        "absolute flex top-0 right-0 -space-x-px animate-[fade-in_0.2s_ease-out]",
        className,
      )}
      style={{
        height: "1000px",
        width: "400px",
        transformOrigin: "top left",
        transform: "translate(100%, 0) rotate(45deg)",
        ...(style || {}),
      }}
    >
      {STRIPES.map((token) => (
        <div
          key={token}
          className="flex-1"
          style={{
            backgroundColor: `var(${token})`,
            transform: "translateY(-50%) scaleY(10)",
          }}
        />
      ))}
    </div>
  </div>
);
